















import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import UserIcon from '@/components/common/UserIcon.vue'
import HavingWebRTCMediaMixin from '@/mixins/webrtc/havingWebRTCMediaMixin'
import { MediaTypes } from '@/webrtc/constants/mediaTypes'

@Component
export default class VideoCallUserIcon extends mixins(
  UserIcon,
  HavingWebRTCMediaMixin
) {
  @Prop(Boolean) muted!: boolean
  @Prop(MediaStream) stream!: MediaStream

  handleClickUserIcon() {
    this.$emit('select', this.id)
  }

  mounted() {
    this.initialize(this.stream, this.muted, [MediaTypes.audio])
  }
}
